var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"fade"}},[(!_vm.contentReady)?_c('Intro'):_vm._e()],1),_c('Content',{attrs:{"ready":_vm.contentReady}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }